var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { appear: "", name: "slide-fade" } }, [
    _vm.show
      ? _c(
          "div",
          { staticClass: "flex gap-2 fixed debug-bar" },
          [
            _c(
              "b-button",
              {
                staticClass: "close-debug rounded-full",
                attrs: { variant: "outline-danger", size: "sm" },
                on: {
                  click: function($event) {
                    _vm.intentShow = false
                  }
                }
              },
              [
                _c("b-icon-x-circle-fill", {
                  staticClass: "pointer-events-none"
                })
              ],
              1
            ),
            _c(
              "div",
              {
                staticClass:
                  "flex items-center gap-2 overflow-y-hidden overflow-x-auto",
                staticStyle: { "max-width": "30rem" }
              },
              [_vm._t("default")],
              2
            ),
            _c("div", { staticClass: "w-24" }),
            _c(
              "div",
              {
                staticClass:
                  "absolute text-xs text-danger font-bold pointer-events-none",
                staticStyle: { bottom: "0", right: "0.1rem" }
              },
              [_vm._v(" DEBUG ATIVO ")]
            )
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }